import { useState } from "react";
import { Column, Row, Spacer } from "../../../../components/Layout/Layout";
import useTranslations from "../../../../core/i18n/useTranslations";
import { AlarmCodeTable } from "./AlarmCodeTable";
import CreateAlarmCodeModal from "./CreateAlarmCodeModal";
import EditAlarmCodeModal from "./EditAlarmCodeModal";

export const AlarmCodes = ({
  responseCenterId,
}: {
  responseCenterId: string | number;
}) => {
  const t = useTranslations();
  const [reloadTableFlag, setReloadTableFlag] = useState(false);

  const [upForEdit, setUpForEdit] = useState<number | undefined>();

  const requestRefetch = () => {
    setReloadTableFlag(!reloadTableFlag);
  };

  return (
    <Column className="w-100" type="top" align="start">
      <h1>{t("AlarmReceptions:alarm_handling_alarm_codes")}</h1>
      <Spacer size={8} />
      <p className="grey-600">{t("AlarmReceptions:alarm_codes_description")}</p>
      <Spacer size={16} />
      <Row className="w-100 flex0" type="space">
        <h2>{t("AlarmReceptions:list_of_codes")}</h2>
        <Spacer />
        <CreateAlarmCodeModal
          responseCenterId={responseCenterId}
          onAdd={requestRefetch}
        />
      </Row>
      <Spacer size={32} />
      <AlarmCodeTable
        responseCenterId={responseCenterId}
        onStartEdit={(rowData) => {
          setUpForEdit(rowData.id);
        }}
        fetchFlag={reloadTableFlag}
      />
      {upForEdit && (
        <EditAlarmCodeModal
          responseCenterId={responseCenterId}
          alarmCodeId={upForEdit}
          onClose={() => setUpForEdit(undefined)}
          onEdit={requestRefetch}
        />
      )}
    </Column>
  );
};
